<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a href="javascript:void(0)" @click="openUserGroupManager()">
            投票人员分组
          </a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="currentSpan">
            （{{ userGroupInfo.MeetingUserGroupName }}）投票人员
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <el-button @click="openUserGroupManager()"> 返回 </el-button>
        <el-button type="primary" @click="editUser(null)"> 新增人员 </el-button>
        <el-button type="primary" @click="exportTemplate()">
          导出Excel模板
        </el-button>
        <el-button type="primary" @click="importData()"> 导入数据 </el-button>
      </div>
    </div>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            {{ userGroupInfo.MeetingUserGroupName }}
          </div>
        </div>
        <div class="form_bar_btn">
          <div class="condition_item">
            <el-input
              placeholder="请输入姓名或用户名"
              v-model="listQuery.KeyWord"
              clearable
              @clear="clearSearch()"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchUsers()"
              ></el-button>
            </el-input>
          </div>
          <div class="condition_item">
            <el-button @click="openUserGroupManager()"> 返回 </el-button>
            <el-button type="primary" @click="editUser(null)">
              新增人员
            </el-button>
            <el-button type="primary" @click="editHostUser(null)">
              新增主持人
            </el-button>
            <el-button type="primary" @click="editScrutineer(null)">
              新增监票人
            </el-button>
          </div>
          <div class="condition_item">
            <el-button type="primary" @click="exportTemplate()">
              导出Excel模板
            </el-button>
            <el-button type="primary" @click="importData()">
              导入数据
            </el-button>
          </div>
          <div class="condition_item">
            <el-button type="primary" @click="userPrint()"> 打印 </el-button>
            <el-button type="primary" @click="userSinglePrint()">
              单页打印
            </el-button>
          </div>
        </div>
      </div>
      <el-table
        v-loading="tableLoading"
        :data="userList"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        stripe
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="60"
        ></el-table-column>
        <el-table-column property="UserName" label="姓名"> </el-table-column>
        <el-table-column property="Phone" label="用户名" align="center">
        </el-table-column>
        <el-table-column label="角色" align="center">
          <template slot-scope="scope">
            <span>
              <i
                class="iconfont icon-zhuchiren"
                v-if="scope.row.RoleId === 2"
              ></i>
              <i
                class="iconfont icon-shezhijiaose"
                v-if="scope.row.RoleId === 7"
              ></i>
              {{ scope.row.RoleName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          property="UserVoteNumber"
          label="权重(票数)"
          align="center"
        >
        </el-table-column>
        <el-table-column property="Password" label="密码" align="center">
        </el-table-column>
        <el-table-column label="显示顺序" width="70" align="center" key="Sort">
          <template slot-scope="scope">
            <span>{{ scope.row.Sort }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="editUser(scope.row.GroupStaffID)"
              v-if="scope.row.RoleId === 0"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="editHostUser(scope.row.GroupStaffID)"
              v-if="scope.row.RoleId === 2"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="editScrutineer(scope.row.GroupStaffID)"
              v-if="scope.row.RoleId === 7"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="deleteUser(scope.row)"
              v-if="scope.row.VoteNames.length === 0"
            >
              删除
            </el-link>
            <el-popover placement="left" width="400" trigger="hover">
              <el-table :data="scope.row.VoteNames">
                <el-table-column width="400" label="被以下投票使用">
                  <template slot-scope="scope1">
                    <span>{{ scope1.row }}</span>
                  </template></el-table-column
                >
              </el-table>
              <el-link
                title="被以下投票使用"
                type="primary"
                class="cell_link"
                slot="reference"
                v-if="scope.row.VoteNames.length !== 0"
                :disabled="scope.row.VoteNames.length !== 0"
              >
                删除
                <i class="el-icon-connection el-icon--right"></i>
              </el-link>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.MaxResultCount"
          :layout="pagination_layout"
          :total="listTotalCount"
        >
        </el-pagination>
      </div>
      <EditUser
        :MeetingGroupID="userGroupId"
        :MeetingID="meetingId"
        :IsShowHeadPicture="true"
        :fatherSubmitDialog="editUserDialog"
        ref="editUser"
      ></EditUser>
      <EditHostUser
        :MeetingGroupID="userGroupId"
        :MeetingID="meetingId"
        :IsShowHeadPicture="true"
        :fatherSubmitDialog="editHostUserDialog"
        ref="editHostUser"
      ></EditHostUser>
      <EditScrutineer
        :MeetingGroupID="userGroupId"
        :MeetingID="meetingId"
        :IsShowHeadPicture="true"
        :fatherSubmitDialog="editScrutineerDialog"
        ref="editScrutineer"
      ></EditScrutineer>
      <ImportExcel
        :fatherSubmitDialog="importExcelDialog"
        ref="importUser"
      ></ImportExcel>
    </div>
  </div>
</template>
<script>
import voteUserApi from '../../../api/vote/voteUser'
import EditUser from '@/components/user/EditUser.vue'
import EditHostUser from '@/components/user/EditHostUser.vue'
import EditScrutineer from '@/components/user/EditScrutineer.vue'
import ImportExcel from '@/components/user/ImportExcel.vue'
export default {
  name: 'Home',
  components: {
    EditUser,
    EditHostUser,
    EditScrutineer,
    ImportExcel
  },
  data () {
    return {
      meetingId: null,
      userGroupId: null,
      tableLoading: true,
      userList: [],
      listTotalCount: 0,
      currentPage: 1,
      listQuery: {
        meetingGroupID: null,
        maxResultCount: 10,
        skipCount: 0
      },
      userGroupInfo: {},
      pagination_layout: 'prev, pager, next'
    }
  },
  methods: {
    getVoteUserGroup: function () {
      this.tableLoading = true
      voteUserApi.getVoteUserGroup({
        meetingUserGroupID: this.userGroupId
      }).then(data => {
        this.userGroupInfo = data
        this.getVoteUsers()
      }).catch(err => {
        return err
      })
    },
    getVoteUsers: function () {
      this.tableLoading = true
      voteUserApi.getVoteUsers(this.listQuery).then(data => {
        this.userList = data.Items
        this.listTotalCount = data.TotalCount
        this.tableLoading = false
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    searchUsers: function () {
      this.listQuery.skipCount = 0
      this.getVoteUsers()
    },
    clearSearch: function () {
      this.listQuery.skipCount = 0
      this.getVoteUsers()
    },
    handleSizeChange (val) {
      this.listQuery.maxResultCount = val
      this.getVoteUsers()
    },
    handleCurrentChange (val) {
      this.listQuery.skipCount = (val - 1) * this.listQuery.maxResultCount
      this.getVoteUsers()
    },
    deleteUser: function (item) {
      this.$confirm('确认删除人员“' + item.UserName + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('删除中…')
        voteUserApi.deleteVoteUser({
          groupStaffId: item.GroupStaffID
        }).then(data => {
          openLoading.close()
          this.getVoteUsers()
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    editUser: function (groupStaffId) {
      this.$refs.editUser.openEditUser(groupStaffId)
    },
    editHostUser: function (groupStaffId) {
      this.$refs.editHostUser.openEditUser(groupStaffId)
    },
    editScrutineer: function (groupStaffId) {
      this.$refs.editScrutineer.openEditUser(groupStaffId)
    },
    editUserDialog: function () {
      this.getVoteUsers()
    },
    editHostUserDialog: function () {
      this.getVoteUsers()
    },
    editScrutineerDialog: function () {
      this.getVoteUsers()
    },
    openUserGroupManager: function () {
      this.$router.push({ name: 'voteUserGroup', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
    },
    indexMethod (index) {
      return this.listQuery.skipCount + index + 1
    },
    exportTemplate: function () {
      const openLoading = this.openLoading('正在导出…')
      voteUserApi.exportMeetingUserTemplate({
        UserGroupID: this.userGroupId
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '投票人员'
        if (this.userGroupId) {
          fileName = this.userGroupInfo.MeetingUserGroupName
        }
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    importData: function () {
      this.$refs.importUser.openImportExcel(this.userGroupId, this.$route.params.mid)
    },
    importExcelDialog: function () {
      this.getVoteUsers()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.RoleId === 2) {
        return 'zhuchiren-row'
      }
      return ''
    },
    userPrint: function () {
      voteUserApi.getUserVoteNumberListByGroupId({
        meetingUserGroupID: this.userGroupId
      }).then(data => {
        data.forEach(item => {
          const routerJump = this.$router.resolve({ name: 'userPrint', params: { mid: this.$route.params.mid, gid: this.$route.params.gid, vn: item, tip: '微信扫码投票' } })
          window.open(routerJump.href, '_blank')
        })
      }).catch(err => {
        return err
      })
    },
    userSinglePrint: function () {
      voteUserApi.getUserVoteNumberListByGroupId({
        meetingUserGroupID: this.userGroupId
      }).then(data => {
        data.forEach(item => {
          const routerJump = this.$router.resolve({ name: 'userSinglePrint', params: { mid: this.$route.params.mid, gid: this.$route.params.gid, vn: item, tip: '微信扫码投票', sn: '0' } })
          window.open(routerJump.href, '_blank')
        })
      }).catch(err => {
        return err
      })
    }
  },
  computed: {

  },
  created () {
    this.meetingId = this.$route.params.mid
    this.userGroupId = this.$route.params.gid
    this.listQuery.meetingGroupID = this.$route.params.gid
    this.getVoteUserGroup()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
<style lang="less">
.el-table .zhuchiren-row {
  background: #d9ecff;
}
</style>
